<script setup lang="ts">
import { onUnmounted, ref, watch } from "vue";
import { Timeline, DOMVideo } from "@zyzgroup/core-web";
import ProgressBar from "../progress/ProgressBar.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { ProgressBar },
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    src: string;
    type?: string;
    autoplay?: boolean;
    width?: string;
    height?: string;
  }>(),
  {
    type: "video/webm",
    autoplay: true,
    width: "320px",
    height: "138px"
  }
);

const emits = defineEmits<{
  (event: "start"): void;
  (event: "complete"): void;
}>();

let tl: Timeline | null;

function onPlay(this: any, _e: Event) {
  if (tl) {
    tl.resume();
    return;
  }
  // if (video.value.readyState === video.value.HAVE_ENOUGH_DATA) {
  tl = new Timeline({
    frameDuration: this.duration * 1000 // e.target.duration
  });
  tl.addTween(
    { x: 0 },
    { x: 100 },
    {
      frames: 1,
      delay: 0,
      onStart: () => {
        emits("start");
        bar.value?.goto(0);
      },
      onUpdate: (obj) => {
        // console.log(obj, e.target.duration, e.target.currentTime);
        bar.value?.goto(obj.x);
      },
      onComplete: () => {
        emits("complete");
        tl = null;
      }
    }
  );
  tl.play();
}

// function onPause(this: any, _e: Event) {
//   console.log("onPause");
//   tl?.pause(); /// tl.pause() 比 tl.onComplete() 早执行
// }

const video = ref();
const bar = ref();

watch(video, () => {
  if (!video.value) {
    return;
  }
  video.value.addEventListener("play", onPlay);
  // video.value.addEventListener("pause", onPause);
  if (props.autoplay) {
    DOMVideo.tryAutoPlayOrAutoPlayAfterClick(video.value);
  }
});

onUnmounted(() => {
  video.value?.removeEventListener(onPlay);
  // video.value?.removeEventListener(onPause);
});

function play() {
  video.value?.play();
}

function pause() {
  video.value?.pause();
  tl?.pause();
}

defineExpose({ play, pause });
</script>

<template>
  <div
    class="video"
    :style="{ width: props.width, height: props.height }"
    @click="play"
  >
    <video
      ref="video"
      :width="props.width"
      :height="props.height"
      preload="metadata"
    >
      <source
        :src="props.src"
        :type="props.type"
      />
    </video>
    <div class="video-progress-bar">
      <ProgressBar
        ref="bar"
        bgColor="#ffffff"
      ></ProgressBar>
    </div>
  </div>
</template>

<!--
  ce 中不要使用v-bind
  color: v-bind(fontColor);
-->
<style scoped>
.video {
  position: relative;
  overflow: hidden;
  background-color: #f5f5f5;
}
.video-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 6px;
}
</style>
